import React from 'react';
import styled from 'styled-components';
import { Image, Snip, getSnip } from 'launchpad';

export default class ContentBlockFullWidth extends React.Component {
  render() {
    return (
      <div>
        <div className="bg-white mt-offset-9">
          <div className="container cp-3-top cp-2-bottom cp-4-top--lg cp-3-bottom--lg">
            <div className="w-md-80 w-lg-60 text-center mx-md-auto mb-9">
              <span className="u-label u-label--sm u-label--purple mb-3"><Snip name="content-block-full-width-label" page={this.props.page}></Snip></span>
              <h2><Snip name="content-block-full-width-heading" page={this.props.page}></Snip></h2>
              <p><Snip name="content-block-full-width-content" page={this.props.page}></Snip></p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}